import { apiFetch } from "./index";

export const getNotifications = async (token: string) => {
  return await apiFetch<MessageNotification[]>(`/api/management/notifications`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUnReadNotifications = async (token: string) => {
  return await apiFetch<MessageNotification[]>(`/api/management/notifications/unread`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const markAsReadNotification = async (token: string, id: number) => {
  return await apiFetch(`/api/management/mark-as-read/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const markAllAsReadNotification = async (token: string) => {
  return await apiFetch(`/api/management/mark-all-read`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteNotification = async (token: string, id: number) => {
  return await apiFetch(`/api/management/notifications/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateNotificationSettings = async (token: string, settings: any) => {
  return await apiFetch<void>("/api/management/notification-settings", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(settings),
  });
}

export interface MessageNotification {
  id: number;
  title: string;
  content: string;
  datetime?: string;
  read: boolean;
}